import { useContext } from "react"
import { PalmistryContext } from "../providers/palmistry-context"

export function usePalmistryContext() {
  return useContext(PalmistryContext)
}
